"use client"
import { useUserInfoStore } from "@/models/userInfo";
import { jwtDecode } from "jwt-decode";
import useStatusStore from "@/models/status";
// 上线时需要关闭
const is_DEV_MODE = false
// 配合Login组件，实现登录检查，并在isLogin时校验JWT的exp是否过期
const useLogin = () => {
    const { loginModalVisible, setLoginModalVisible } = useStatusStore();
    const { isLogin, userInfo } = useUserInfoStore();

    // 检查token是否过期
    const isTokenExpired = (token: string | undefined): boolean => {
        if (!token) return true;
        try {
            const decoded: any = jwtDecode(token);
            if (!decoded.exp) return true;
            const now = Math.floor(Date.now() / 1000);
            return decoded.exp < now;
        } catch (e) {
            return true;
        }
    };

    const checkLogin = (handle: (...args: any[]) => any) => {
        return (...args: any[]) => {
            if (is_DEV_MODE) {
                handle(...args);
            } else if (isLogin) {
                // 检查token是否过期
                if (isTokenExpired(userInfo.jwt_token)) {
                    setLoginModalVisible(true);
                } else {
                    handle(...args);
                }
            } else {
                setLoginModalVisible(true);
            }
        }
    }

    return { isLogin, checkLogin, loginModalVisible, setLoginModalVisible, isTokenExpired };
}

export default useLogin;